<div class="row" >
  <ng-container *ngFor='let resumeCard of cardResumeData()' >
    <div class="col-sm-4 m-0 p-0" >
      <div class="card"  [attr.data-status]="resumeCard.title" [class.active]="currentResumeSelected === resumeCard.title" (click)="onSubmit(resumeCard.title)" >
        <div class="card-body">
          <div class="dash-widget-header">
            <span class="dash-widget-icon m-0">
              <i [class]="resumeCard.icon"></i>
            </span>
            <div class="dash-count m-0 p-2">
              <h2 class="m-0 mt-2 text-h2">{{ resumeCard.value ? resumeCard.value: '0' }}</h2>
              <h3 class="text-muted">{{ ((resumeCard.title + '.title')| translate).toLocaleUpperCase() }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
